import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import { Union } from 'ts-toolbelt';

import { InitialValues, ValidationErrors } from 'forms/types';
import { composeValidators, isDateInPast, isDateOnOrAfterDOB, isPresent } from 'forms/validators';

import { DepressionFormValues } from '../form/types';

export const getValidator = ({ dateOfBirth }: { dateOfBirth: Union.Nullable<string> }) => {
  const dobValidator = composeValidators(isPresent, isDateInPast, isDateOnOrAfterDOB(dateOfBirth));

  return ({
    diagnosedAt,
    severity,
    currentlyTreated,
    everTreated,
    treatmentEndDate,
    numberOfMedications,
    psychotherapy,
    hospitalized,
    hospitalizedAt,
  }: InitialValues<DepressionFormValues>): ValidationErrors<DepressionFormValues> => {
    const errors: ValidationErrors<DepressionFormValues> = {
      diagnosedAt: dobValidator(diagnosedAt),
      severity: isPresent(severity),
      currentlyTreated: isPresent(currentlyTreated),
      hospitalized: isPresent(hospitalized),
    };

    if (currentlyTreated) {
      errors.numberOfMedications = isPresent(numberOfMedications);
      errors.psychotherapy = isPresent(psychotherapy);
    } else if (currentlyTreated === false) {
      errors.everTreated = isPresent(everTreated);
      if (everTreated) {
        errors.treatmentEndDate = dobValidator(treatmentEndDate);
      }
    }

    if (hospitalized) {
      errors.hospitalizedAt = dobValidator(hospitalizedAt);
    }

    return omitBy(errors, isNil);
  };
};
